export default __webpack_public_path__ + "static/media/compliance-violation.1d9a24dd.svg";